setTimeout(function() {
    var element = document.querySelectorAll(".qsk-popup__close");
    if (element && element.length > 0) {
        element[0].href = "#";
    }
}, 100); // 2000 milliseconds = 3 seconds